import React from 'react'
import clsx from 'clsx'

import { ListWithTextTypes } from './types'
import * as styles from './ListWithText.module.css'

export function ListWithText({ list_items }: ListWithTextTypes) {
  return (
    <div className="flex flex-col w-8/12 tablet:w-auto">
      {list_items?.length &&
        list_items?.map((item) => (
          <React.Fragment key={item.title}>
            <p className="font-poppins font-bold text-bodyL text-text-dark-900 tablet:text-lg h-80 pr-0 tablet:pr-32 pl-48 flex items-center">
              {item.title}
            </p>
            {item.text_items?.map(({ text, _uid }) => (
              <div key={_uid} className={clsx('flex items-center h-80 pr-0 tablet:pr-32', styles.list)}>
                <p className="font-poppins text-bodyL leading-snug text-text-dark-900 pl-48">{text}</p>
              </div>
            ))}
          </React.Fragment>
        ))}
    </div>
  )
}
